<form class="f-col blank-form">
    <div class="section-heading">
      <h2 class="h2-heading">{{content?.['b2b.managepolicy.upgradepolicy']}} <div class="dot">.</div> <span class="optional">Optional</span></h2>
      <!-- <a role="button" class="link"><mat-icon fontSet="material-symbols-outlined" class="edit-icon">edit</mat-icon> Edit</a> -->
    </div>
  
    <div class="section-content" [formGroup]="upgradePolicyCopyForm">
        <mat-tab-group [selectedIndex]="commonObj.tabIndex"  (selectedTabChange)="tabChange($event)">
            <mat-tab label="Guest">
                <div class="inner-contentsection" formGroupName="Guest">
                    <div class="f-row">
                        <div class="f-col">
                          <div class="f-row validation-col policy-row" formGroupName="upgrade">
                            <label class="mat-label">{{content?.['b2b.managepolicy.flighthrs']}} </label>
                            <div class="hour-mintue-col">
                                <mat-form-field>
                                    <mat-label>{{content?.['b2b.managepolicy.hh']}}</mat-label>
                                    <input matInput formControlName="hh">
                                </mat-form-field>
                            </div>
                            <div class="hour-mintue-col">
                                <mat-form-field>
                                    <mat-label>{{content?.['b2b.managepolicy.mm']}}</mat-label>
                                    <input matInput formControlName="mm">
                                </mat-form-field>
                            </div>
                            <div class="field-col">
                                <ng-select autoBlurSelect [items]="commonApiLists.cabinCategory" formControlName="cabin" [placeholder]="content?.['b2b.managepolicy.cabincategory']" (change)="dropdownChange('Guest.additional.cabin')"></ng-select>
                                <mat-error class="px-4" *ngIf="upgradePolicyCopyForm.get('Guest.upgrade.cabin')?.hasError('required') && upgradePolicyCopyForm.get('Guest.upgrade.cabin')?.touched"> Upgrade Cabin Category is required.</mat-error>
                            </div>
                          </div>
                        </div>
                    </div>
                    <div class="f-row">
                        <div class="f-col configuration-row">
                            <div class="f-row condiional-rows">
                                <div class="condition-block cmcondition-block">{{content?.['b2b.managepolicy.or']}}</div>
                                <div class="f-row validation-col policy-row" formGroupName="additional">
                                    <label class="mat-label">{{content?.['b2b.managepolicy.flighthrs']}} </label>
                                    <div class="hour-mintue-col">
                                        <mat-form-field>
                                            <mat-label>{{content?.['b2b.managepolicy.hh']}}</mat-label>
                                            <input matInput formControlName="hh">
                                        </mat-form-field>
                                    </div>
                                    <div class="hour-mintue-col">
                                        <mat-form-field>
                                            <mat-label>{{content?.['b2b.managepolicy.mm']}}</mat-label>
                                            <input matInput formControlName="mm">
                                        </mat-form-field>
                                    </div>
                                    <div class="field-col" [class.view-disabled]="upgradePolicyCopyForm.value.Guest.upgrade.cabin == 'First'">
                                        <ng-select autoBlurSelect [items]="commonApiLists[upgradePolicyCopyForm.value.Guest.upgrade.cabin]" formControlName="cabin" [placeholder]="content?.['b2b.managepolicy.cabincategory']"></ng-select>
                                        <mat-error class="px-4" *ngIf="upgradePolicyCopyForm.get('additional.upgrade.cabin')?.hasError('required') && upgradePolicyCopyForm.get('additional.upgrade.cabin')?.touched"> Upgrade Cabin Category is required.</mat-error>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="f-row">
                        <div class="f-col configuration-row">
                            <div class="f-row condiional-rows">
                            <div class="condition-block">{{content?.['b2b.managepolicy.and']}}</div>
                            <div class="f-row validation-col policy-row">
                                <label class="mat-label">{{content?.['b2b.managepolicy.layovertime']}}</label>
                                <mat-radio-group aria-label="Select an option" formControlName="layover">
                                    <mat-radio-button value="Inclusive">{{content?.['b2b.managepolicy.inclusive']}}</mat-radio-button>
                                    <mat-radio-button value="Exclusive">{{content?.['b2b.managepolicy.exclusive']}}</mat-radio-button>
                                </mat-radio-group>
                                </div>
                            </div>
                        </div>
                    </div> 
                </div> 
            </mat-tab>
            <mat-tab label="Business"> 
                <div class="inner-contentsection" formGroupName="Business">
                    <div class="f-row">
                        <div class="f-col">
                          <div class="f-row validation-col policy-row" formGroupName="upgrade">
                            <label class="mat-label">{{content?.['b2b.managepolicy.flighthrs']}} </label>
                            <div class="hour-mintue-col">
                                <mat-form-field>
                                    <mat-label>{{content?.['b2b.managepolicy.hh']}}</mat-label>
                                    <input matInput formControlName="hh">
                                </mat-form-field>
                            </div>
                            <div class="hour-mintue-col">
                                <mat-form-field>
                                    <mat-label>{{content?.['b2b.managepolicy.mm']}}</mat-label>
                                    <input matInput formControlName="mm">
                                </mat-form-field>
                            </div>
                            <div class="field-col">
                                <ng-select autoBlurSelect [items]="['First']" formControlName="cabin" [placeholder]="content?.['b2b.managepolicy.cabincategory']"></ng-select>
                            </div>
                          </div>
                        </div>
                    </div>
                    <div class="f-row">
                        <div class="f-col configuration-row">
                            <div class="f-row condiional-rows">
                            <div class="condition-block">{{content?.['b2b.managepolicy.and']}}</div>
                                <div class="f-row validation-col policy-row">
                                    <label class="mat-label">{{content?.['b2b.managepolicy.layovertime']}}</label>
                                    <mat-radio-group aria-label="Select an option" formControlName="layover">
                                        <mat-radio-button value="Inclusive">{{content?.['b2b.managepolicy.inclusive']}}</mat-radio-button>
                                        <mat-radio-button value="Exclusive">{{content?.['b2b.managepolicy.exclusive']}}</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>
                        </div>
                    </div> 
                </div>     
            </mat-tab>
          </mat-tab-group>
        <div class="inner-action">
            <button mat-button class="button--secondary-small" type="button" (click)="navigateToList()">{{content?.['b2b.managepolicy.cancel']}}</button>
            <button mat-button class="button--primary-small" (click)="save()" [class.disabled]="upgradePolicyCopyForm.get('Guest')?.invalid || upgradePolicyCopyForm.get('Business')?.invalid" [disabled]="commonObj.isSubmitting">
            <!-- <button mat-button class="button--primary-small" (click)="save()"> -->
                {{content?.['b2b.managepolicy.save']}}
                <ng-container *ngIf="commonObj.isSubmitting">
                    <mat-spinner class="button"></mat-spinner>
                </ng-container>
            </button>
        </div>
    </div>
  </form>